/**
 * Validates if a string is a properly formatted email address.
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  return emailRegex.test(email);
};

/**
 * Checks if a string contains potentially malicious payloads (basic XSS/SQLi).
 * Returns true if the input is safe, false if a payload is detected.
 */
export const isSafeInput = (text: string): boolean => {
  if (!text) return true;
  
  // Basic XSS patterns (script tags, event handlers, javascript URIs, and basic HTML evasion)
  const xssPattern = /(<script\b[^>]*>[\s\S]*?<\/script>|<.*?on\w+\s*=.*?>|javascript:|data:text\/html|vbscript:|<iframe|<object|<embed)/gi;
  
  // Basic SQLi payloads (blatant injection attempts, since Supabase handles parameterized queries natively)
  const sqliPattern = /(\b(UNION\s+(ALL\s+)?SELECT|DROP\s+TABLE|DELETE\s+FROM|INSERT\s+INTO|UPDATE\s+\w+\s+SET)\b|--\s*$|\b(OR|AND)\s+'?1'?='?1'?|\bWAITFOR\s+DELAY\b)/gi;
  
  if (xssPattern.test(text) || sqliPattern.test(text) || text.includes("<script") || text.includes("<img")) {
    return false;
  }
  
  return true;
};
